import Requests from "./Requests";
import BackNav from "../../../components/toolbars/BackNav";
import { useParams } from "react-router";

export default function ByStatus() {
  const status = useParams().status;
  return (
    <div>
      <BackNav />
      <Requests status={status} />
    </div>
  );
}
